import { useMutation as s, useQuery as r } from "@tanstack/react-query";
import { bs as o, k as i, j as a, a8 as c, m as y, an as C, ac as m, au as q, v, br as p, a1 as f, F as l, x as d, Z as A, a as K, d as x, Q as F, R as L, S as g, am as G, ay as P, a9 as R, aa as E, ab as Q, aC as T, ao as h, at as S, av as w, u as I, ae as M, ax as N, az as D, bm as U, bc as O, bt as j, bu as z, bq as k, a2 as B, a4 as Y, a5 as Z, a7 as $, bp as H, bo as u, w as J, E as V, e as W, aA as X, s as _, a0 as b, bn as ee, G as te, I as ne, K as re, L as se, Y as ue, C as oe, ar as ie, f as ae, ah as ce, bd as ye, N as Ce, D as me, B as qe, $ as ve } from "./services.gen-D7DK4RCL.js";
import { g as yn, c as Cn, e as mn, u as qn, a as vn, b as pn, d as fn, f as ln, h as dn } from "./useReviseConversationExpertResult-D8w2nkRT.js";
function We(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => o(n),
      ...e
    })
  };
}
function Xe(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => i(n),
      ...e
    })
  };
}
function _e(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: () => a(),
      ...e
    })
  };
}
function be(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => c(n),
      ...e
    })
  };
}
function et(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => y(n),
      ...e
    })
  };
}
function tt(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => C(n),
      ...e
    })
  };
}
function nt(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => m(n),
      ...e
    })
  };
}
function rt(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => q(n),
      ...e
    })
  };
}
function st(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => v(n),
      ...e
    })
  };
}
function ut(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => p(n),
      ...e
    })
  };
}
function ot(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => f(n),
      ...e
    })
  };
}
function it(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => l(n),
      ...e
    })
  };
}
function at(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => d(n),
      ...e
    })
  };
}
function ct(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => A(n),
      ...e
    })
  };
}
const pe = () => ["accountList"];
function yt(e) {
  return {
    ...r({
      queryKey: pe(),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => K(),
      ...e
    })
  };
}
function Ct(e) {
  return {
    ...r({
      queryKey: ["accountAccountsList"],
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => x(),
      ...e
    })
  };
}
function fe() {
  return ["authSocialList"];
}
function mt(e) {
  return {
    ...r({
      queryKey: fe(),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => F(),
      ...e
    })
  };
}
function le() {
  return ["authSsoList"];
}
function qt(e) {
  return {
    ...r({
      queryKey: le(),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => L(),
      ...e
    })
  };
}
function vt(e) {
  return {
    ...r({
      queryKey: ["authTestList"],
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => g(),
      cacheTime: 0,
      ...e
    })
  };
}
function de(e) {
  return ["conversationApplicationConversationRead", e];
}
function pt(e, t) {
  return {
    ...r({
      queryKey: de(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => G(e),
      ...t
    })
  };
}
function Ae(e) {
  return ["conversationCouncilConversationsRead", e];
}
function ft(e, t) {
  return {
    ...r({
      queryKey: Ae(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => P(e),
      ...t
    })
  };
}
function Ke(e) {
  return ["conversationAdminConversationExecutionGraph", e];
}
function lt(e, t) {
  return {
    ...r({
      queryKey: Ke(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => R(e),
      ...t
    })
  };
}
function xe(e) {
  return ["conversationAdminConversationsList", e];
}
function dt(e, t) {
  return {
    ...r({
      queryKey: xe(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => E(e),
      ...t
    })
  };
}
function Fe(e) {
  return ["conversationAdminConversationExpertResultsList", e];
}
function At(e, t) {
  return {
    ...r({
      queryKey: Fe(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => Q(e),
      ...t
    })
  };
}
function Le(e) {
  return ["conversationMessagesGraph", e];
}
function Kt(e, t) {
  return {
    ...r({
      queryKey: Le(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => T(e),
      ...t
    })
  };
}
function ge(e) {
  return [
    "conversationApplicationConversationMessagesList",
    e
  ];
}
function xt(e, t) {
  return {
    ...r({
      queryKey: ge(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => h(e),
      ...t
    })
  };
}
function Ge(e) {
  return ["conversationConversationsNotesList", e];
}
function Ft(e, t) {
  return {
    ...r({
      queryKey: Ge(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => S(e),
      ...t
    })
  };
}
function Pe(e) {
  return ["conversationConversationsReviewsList", e];
}
function Lt(e, t) {
  return {
    ...r({
      queryKey: Pe(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => w(e),
      ...t
    })
  };
}
function Re(e) {
  return [
    "assessmentConversationAssessmentReviewStatesList",
    e
  ];
}
function gt(e, t) {
  return {
    ...r({
      queryKey: Re(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => I(e),
      ...t
    })
  };
}
function Ee(e) {
  return ["conversationAdminConversationsList", e];
}
function Gt(e, t) {
  return {
    ...r({
      queryKey: Ee(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => M(e),
      ...t
    })
  };
}
function Qe(e) {
  return ["conversationCouncilConversationsList", e];
}
function Pt(e, t) {
  return {
    ...r({
      queryKey: Qe(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => N(e),
      ...t
    })
  };
}
function Te(e) {
  return ["conversationPanelsList", e];
}
function Rt(e, t) {
  return {
    ...r({
      queryKey: Te(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => D(e),
      ...t
    })
  };
}
function he() {
  return ["expertExpertConfigTypesList"];
}
function Et(e) {
  return {
    ...r({
      queryKey: he(),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => U(),
      ...e
    })
  };
}
function Se(e) {
  return ["expertContextCuttersList", e];
}
function Qt(e, t) {
  return {
    ...r({
      queryKey: Se(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => O(e),
      ...t
    })
  };
}
function we(e) {
  return ["expertPanelsRead", e];
}
function Tt(e, t) {
  return {
    ...r({
      queryKey: we(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => j(e),
      ...t
    })
  };
}
function Ie(e) {
  return ["expertPanelsRead", e];
}
function ht(e, t) {
  return {
    ...r({
      queryKey: Ie(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => z(e),
      ...t
    })
  };
}
function Me(e) {
  return ["expertPanelsList", e];
}
function St(e, t) {
  return {
    ...r({
      queryKey: Me(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => k(e),
      ...t
    })
  };
}
function Ne(e) {
  return ["conversationAdminConversationTestPanelRead", e];
}
function wt(e, t) {
  return {
    ...r({
      queryKey: Ne(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => B(e),
      ...t
    })
  };
}
function De(e) {
  return [
    "conversationAdminConversationTestPanelResultsList",
    e
  ];
}
function It(e, t) {
  return {
    ...r({
      queryKey: De(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => Y(e),
      ...t
    })
  };
}
function Ue(e) {
  return [
    "conversationAdminConversationTestPanelResultsGroupedList",
    e
  ];
}
function Mt(e, t) {
  return {
    ...r({
      queryKey: Ue(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => Z(
        e
      ),
      ...t
    })
  };
}
function Oe(e) {
  return ["conversationAdminConversationTestPanelsList", e];
}
function Nt(e, t) {
  return {
    ...r({
      queryKey: Oe(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => $(e),
      ...t
    })
  };
}
function je(e) {
  return ["expertLlmProvidersList", e];
}
function Dt(e, t) {
  return {
    ...r({
      queryKey: je(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => H(e),
      ...t
    })
  };
}
function ze(e) {
  return ["expertExpertsListList", e];
}
function Ut(e, t) {
  return {
    ...r({
      queryKey: ze(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => u(e),
      ...t
    })
  };
}
function ke(e) {
  return ["assessmentIssueCategoryList", e];
}
function Ot(e, t) {
  return {
    ...r({
      queryKey: ke(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => J(e),
      ...t
    })
  };
}
function Be(e) {
  return ["assessmentIssuesList", e];
}
function jt(e, t) {
  return {
    ...r({
      queryKey: Be(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => V(e),
      ...t
    })
  };
}
function Ye(e) {
  return ["addressAddressNearObjectsRead", e];
}
function zt(e, t) {
  return {
    ...r({
      queryKey: Ye(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => W(e),
      ...t
    })
  };
}
function Ze(e) {
  return ["conversationPublicConversationRead", e];
}
function kt(e, t) {
  return {
    ...r({
      queryKey: Ze(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => X(e),
      ...t
    })
  };
}
function $e(e) {
  return ["assessmentAssessmentReviewStateDefinitionList", e];
}
function Bt(e, t) {
  return {
    ...r({
      queryKey: $e(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => _(e),
      ...t
    })
  };
}
function He(e) {
  return ["conversationAdminConversationTestGroupsList", e];
}
function Yt(e, t) {
  return {
    ...r({
      queryKey: He(e),
      // @ts-expect-error figure out how to define generic arguments for useMutation
      queryFn: () => b(e),
      ...t
    })
  };
}
function Zt(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => ee(n),
      ...e
    })
  };
}
function $t(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => u(n),
      ...e
    })
  };
}
function Ht(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => te(n),
      ...e
    })
  };
}
function Jt(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: () => ne(),
      ...e
    })
  };
}
function Vt(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => re(n),
      ...e
    })
  };
}
function Wt(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => se(n),
      ...e
    })
  };
}
function Xt(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => ue(
        n
      ),
      ...e
    })
  };
}
function _t(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => oe(n),
      ...e
    })
  };
}
function bt(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => ie(n),
      ...e
    })
  };
}
function en(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => ae(n),
      ...e
    })
  };
}
function tn(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => ce(n),
      ...e
    })
  };
}
function nn(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => ye(n),
      ...e
    })
  };
}
function rn(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => Ce(n),
      ...e
    })
  };
}
function sn(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => me(n),
      ...e
    })
  };
}
function un(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => qe(n),
      ...e
    })
  };
}
function on(e) {
  return {
    ...s({
      // @ts-expect-error figure out how to define generic arguments for useMutation
      mutationFn: (n) => ve(n),
      ...e
    })
  };
}
export {
  pe as getAccountQueryKey,
  yn as getAnalyticsDataQueryKey,
  fe as getAuthSocialListQueryKey,
  le as getAuthSsoListQueryKey,
  Cn as getConversationAsAdminQueryKey,
  Ae as getConversationAsCouncilQueryKey,
  Ke as getConversationExecutionGraphQueryKey,
  xe as getConversationExecutionsAsAdminQueryKey,
  Fe as getConversationExpertResultsQueryKey,
  Le as getConversationMessageGraphQueryKey,
  ge as getConversationMessagesQueryKey,
  Ge as getConversationNotesQueryKey,
  Te as getConversationPanelsQueryKey,
  de as getConversationQueryKey,
  Re as getConversationReviewStatesQueryKey,
  Pe as getConversationReviewsQueryKey,
  Ee as getConversationsAsAdminQueryKey,
  Qe as getCouncilConversationsQueryKey,
  mn as getCouncilsQueryKey,
  he as getExpertConfigTypesQueryKey,
  Se as getExpertContextCuttersQueryKey,
  Ie as getExpertPanelGraphQueryKey,
  we as getExpertPanelQueryKey,
  Ne as getExpertPanelTestQueryKey,
  Ue as getExpertPanelTestResultsGroupedQueryKey,
  De as getExpertPanelTestResultsQueryKey,
  Oe as getExpertPanelTestsQueryKey,
  Me as getExpertPanelsQueryKey,
  je as getExpertProvidersQueryKey,
  ze as getExpertsListQueryKey,
  ke as getGetIssueCategoriesQueryKey,
  Be as getGetIssuesQueryKey,
  Ye as getObjectsNearAddressQueryKey,
  Ze as getPublicConversationQueryKey,
  $e as getReviewStateFieldDefinitionsQueryKey,
  He as getTestGroupsQueryKey,
  We as useArchiveExpertPanel,
  Xe as useCancelOrCompleteApplication,
  _e as useCancelOrCompleteCurrentApplication,
  be as useChangeConversationPanel,
  et as useCreateApplication,
  tt as useCreateConversationMessage,
  nt as useCreateConversationMessageAsAdmin,
  rt as useCreateConversationNote,
  qn as useCreateConversationReview,
  st as useCreateConversationReviewState,
  ut as useCreateExpertPanel,
  ot as useCreateExpertPanelTest,
  it as useCreateIssue,
  at as useCreateIssueCategory,
  ct as useCreateTestGroup,
  yt as useGetAccount,
  Ct as useGetAccounts,
  vn as useGetAddressSuggestions,
  pn as useGetAnalyticsData,
  mt as useGetAuthSocialList,
  qt as useGetAuthSsoList,
  vt as useGetAuthTest,
  pt as useGetConversation,
  fn as useGetConversationAsAdmin,
  ft as useGetConversationAsCouncil,
  lt as useGetConversationExecutionGraph,
  dt as useGetConversationExecutionsAsAdmin,
  At as useGetConversationExpertResults,
  Kt as useGetConversationMessageGraph,
  xt as useGetConversationMessages,
  Ft as useGetConversationNotes,
  Rt as useGetConversationPanels,
  gt as useGetConversationReviewStates,
  Lt as useGetConversationReviews,
  Gt as useGetConversationsAsAdmin,
  Pt as useGetCouncilConversations,
  ln as useGetCouncils,
  Et as useGetExpertConfigTypes,
  Qt as useGetExpertContextCutters,
  Tt as useGetExpertPanel,
  ht as useGetExpertPanelGraph,
  wt as useGetExpertPanelTest,
  It as useGetExpertPanelTestResults,
  Mt as useGetExpertPanelTestResultsGrouped,
  Nt as useGetExpertPanelTests,
  St as useGetExpertPanels,
  Dt as useGetExpertProviders,
  Ut as useGetExpertsList,
  Ot as useGetIssueCategories,
  jt as useGetIssues,
  zt as useGetObjectsNearAddress,
  kt as useGetPublicConversation,
  Bt as useGetReviewStateFieldDefinitions,
  Yt as useGetTestGroups,
  Zt as useLazyGetExpertFullPrompt,
  $t as useLazyGetExpertsList,
  Ht as useLogin,
  Jt as useLogout,
  Vt as usePasswordReset,
  Wt as usePasswordResetConfirm,
  Xt as useRateConversationExpertResult,
  _t as useResolveIssue,
  dn as useReviseConversationExpertResult,
  bt as useSaveReport,
  en as useSelectAddress,
  tn as useSendConversationToCouncil,
  nn as useSetDefaultPanel,
  rn as useSignUp,
  sn as useUnResolveIssue,
  un as useUpdateIssue,
  on as useUpdateTestGroup
};
//# sourceMappingURL=apiHooks.js.map
